import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PageHead from "../../../Components/PageHead/PageHead";
import DataTable from "../../../Components/DataTable/DataTable";
import { Get } from "../../../Services/Server";
import Url from "../../../Services/Url";
import "./Survery.css";
import Utils from "../../../Services/Utills";

const SurveryList = ({ navoption, ModalAction }) => {
	const Navigate = useNavigate();
	const [surveyList, setSurveyList] = useState([]);
	const [view, setView] = useState("pending");
	const [currentPage, setCurrentPage] = useState(0);
	const itemsPerPage = 20;

	useEffect(() => {
		Get(Url.survey.surveyList)
			.then((response) => {
				const data = Array.isArray(response) ? response : [];

				const formattedData = data.map((item) => ({
					id: item.id,
					job_id: item.job_id,
					companyName: item.company_name || "N/A",
					reviewer:
						`${item.reviewer_first_name || ""} ${
							item.reviewer_last_name || ""
						}`.trim() || "N/A",
					location: item.site_addr || "N/A",
					date: item.created_at
						? new Date(item.created_at).toLocaleDateString()
						: "N/A",
					status: item.status?.toLowerCase() || "pending",
				}));

				formattedData.sort((a, b) => b.job_id - a.job_id);

				setSurveyList(formattedData);
			})
			.catch((error) => {
				console.error("Error fetching survey list:", error);
			});
	}, []);

	const filteredList = surveyList.filter((s) => s.status === view);

	const totalPages = Math.ceil(filteredList.length / itemsPerPage);
	const paginatedList = filteredList.slice(
		currentPage * itemsPerPage,
		(currentPage + 1) * itemsPerPage
	);

	const handlePagination = (pg) => {
		setCurrentPage(pg);
	};

	const onSurveyClick = (e) => {
		Navigate(`${e.job_id}`, { state: e });
	};

	const UserRec = (item) => [
		<span key={1}>{Utils.toPascalCase(item.companyName)}</span>,
		<span key={2}>{item.job_id}</span>,
		<span key={3}>{item.location}</span>,
		<span key={4}>{item.date}</span>,
	];

	const heading = ["Company Name", "Job ID", "Location", "Date Submitted"];
	const flex = [30, 15, 35, 20];

	const dropOptions = {
		onClick: (e) => {
			const selectedOption = e.find((o) => o.selected);
			if (selectedOption) {
				setView(selectedOption.text.toLowerCase());
				setCurrentPage(0);
			}
		},
		list: ["Pending", "Ongoing", "Completed", "Closed"],
	};

	return (
		<div className="Survery">
			<PageHead
				navoption={navoption}
				dropOptions={dropOptions}
				filter="Pending"
			/>

			<DataTable
				flex={flex}
				onClick={onSurveyClick}
				reader={UserRec}
				transform={Utils.toPascalCase}
				handlePagination={handlePagination}
				pageable={{ pageNumber: currentPage, pageSize: itemsPerPage }}
				totalPages={totalPages}
			>
				{{
					heading,
					data: paginatedList,
				}}
			</DataTable>
		</div>
	);
};

export default SurveryList;
